(function () {
  var shippingThreshold = 7900;
  var body = document.body;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function lock() {
    body.classList.add('is-locked');
  }

  function unlock() {
    body.classList.remove('is-locked');
  }

  var cartOverlay = document.getElementById('cart-overlay');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartItems = document.getElementById('cart-items');
  var cartFooter = document.getElementById('cart-footer');
  var cartEmpty = document.getElementById('cart-empty');
  var cartCount = document.getElementById('cart-count');
  var cartBadge = document.getElementById('cart-badge');
  var cartSubtotal = document.getElementById('cart-subtotal');

  function setCount(count) {
    var prev = cartBadge ? parseInt(cartBadge.textContent, 10) || 0 : 0;
    if (cartCount) cartCount.textContent = count;
    if (cartBadge) {
      cartBadge.textContent = count;
      cartBadge.style.display = count > 0 ? 'grid' : 'none';
      if (count > prev) {
        cartBadge.classList.remove('bump');
        void cartBadge.offsetWidth;
        cartBadge.classList.add('bump');
        cartBadge.addEventListener('animationend', function () {
          cartBadge.classList.remove('bump');
        }, { once: true });
      }
    }
  }

  function showToast(msg) {
    var toast = document.getElementById('uk-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'uk-toast';
      toast.className = 'uk-toast';
      toast.innerHTML = '<span class="uk-toast__dot"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg></span><span id="uk-toast-text"></span>';
      document.body.appendChild(toast);
    }
    document.getElementById('uk-toast-text').textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('show'); }, 2800);
  }

  function shipping(total) {
    var remaining = shippingThreshold - total;
    if (remaining <= 0) return '<div class="drawer-shipping">Livraison offerte déverrouillée.</div>';
    var pct = Math.min(100, Math.round(total / shippingThreshold * 100));
    return '<div class="drawer-shipping">Encore <strong>' + money(remaining) + '</strong> pour la livraison offerte.<div class="drawer-shipping__bar"><div class="drawer-shipping__fill" style="width:' + pct + '%"></div></div></div>';
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    var ship = cartDrawer && cartDrawer.querySelector('.drawer-shipping-wrap');
    if (ship) ship.innerHTML = shipping(cart.total_price);
    if (!cartItems) return;

    if (!cart.item_count) {
      cartItems.innerHTML = '';
      if (cartFooter) cartFooter.style.display = 'none';
      if (cartEmpty) cartEmpty.style.display = 'flex';
      return;
    }

    if (cartFooter) cartFooter.style.display = 'flex';
    if (cartEmpty) cartEmpty.style.display = 'none';
    if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);

    cartItems.innerHTML = cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>' : '';
      var properties = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          var value = item.properties[key];
          if (value && String(value).trim() && key.charAt(0) !== '_') {
            properties += '<div class="cart-drawer__item-property"><span>' + key + '</span><strong>' + value + '</strong></div>';
          }
        });
      }
      var img = item.image ? '<a href="' + item.url + '" class="cart-drawer__item-img"><img src="' + item.image.replace(/(\\.\\w+)(\\?.*)?$/, '_180x180$1') + '" alt=""></a>' : '';
      return '<div class="cart-drawer__item">' + img + '<div><div class="cart-drawer__item-title">' + item.product_title + '</div>' + variant + properties + '<div class="cart-drawer__item-bottom"><div class="drawer-qty"><button type="button" data-cart-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '">-</button><span>' + item.quantity + '</span><button type="button" data-cart-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button></div><div><span class="cart-drawer__item-price">' + money(item.final_line_price) + '</span> <button type="button" data-cart-change="' + item.key + '" data-qty="0" aria-label="Supprimer" style="border:0;background:transparent;color:rgba(255,255,255,.55)">x</button></div></div></div></div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function openCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartOverlay.classList.add('open');
    cartDrawer.classList.add('open');
    cartDrawer.scrollTop = 0;
    lock();
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartOverlay.classList.remove('open');
    cartDrawer.classList.remove('open');
    unlock();
  }

  var mobileNav = document.getElementById('mobile-nav');
  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    lock();
  }

  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    unlock();
  }

  var search = document.getElementById('srch');
  var searchInput = document.getElementById('srch-input');
  var searchResults = document.getElementById('srch-results');
  var searchEmpty = document.getElementById('srch-empty');
  var searchCats = document.getElementById('srch-cats');
  var searchSeeAll = document.getElementById('srch-see-all');
  var searchTimer;

  function openSearch() {
    if (!search) return;
    search.classList.add('open');
    lock();
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 40);
  }

  function closeSearch() {
    if (!search) return;
    search.classList.remove('open');
    unlock();
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
    if (searchEmpty) searchEmpty.style.display = 'none';
    if (searchCats) searchCats.style.display = 'grid';
    if (searchSeeAll) searchSeeAll.style.display = 'none';
  }

  function searchProducts(query) {
    if (!query || query.length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      if (searchCats) searchCats.style.display = 'grid';
      if (searchEmpty) searchEmpty.style.display = 'none';
      return;
    }

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (((data || {}).resources || {}).results || {}).products || [];
        if (searchCats) searchCats.style.display = 'none';
        if (searchSeeAll) {
          searchSeeAll.href = '/search?type=product&q=' + encodeURIComponent(query);
          searchSeeAll.style.display = products.length ? 'inline-flex' : 'none';
        }
        if (searchEmpty) searchEmpty.style.display = products.length ? 'none' : 'block';
        if (!searchResults) return;
        searchResults.innerHTML = products.map(function (p) {
          var img = p.image ? '<span class="srch__img-wrap"><img src="' + p.image + '" alt=""></span>' : '<span class="srch__img-wrap"></span>';
          var price = p.price || '';
          return '<a class="srch__item" href="' + p.url + '">' + img + '<span><span class="srch__name">' + p.title + '</span></span><span class="srch__price">' + price + '</span></a>';
        }).join('');
      });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-trigger]')) {
      event.preventDefault();
      openCart();
    }
    if (event.target.closest('#cart-close') || event.target === cartOverlay) closeCart();
    if (event.target.closest('[data-mobile-open]')) openMenu();
    if (event.target.closest('[data-mobile-close]') || event.target.closest('.mobile-nav__overlay')) closeMenu();
    if (event.target.closest('#search-open, #search-open-mobile')) {
      event.preventDefault();
      openSearch();
    }
    if (event.target.closest('#srch-x') || event.target === search) closeSearch();
    var change = event.target.closest('[data-cart-change]');
    if (change) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: change.dataset.cartChange, quantity: Math.max(0, parseInt(change.dataset.qty, 10)) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[data-add-btn]');
    if (button) {
      button.disabled = true;
      button.textContent = 'Ajout...';
    }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Erreur'); });
        return r.json();
      })
      .then(function () {
        if (button) {
          button.disabled = false;
          button.textContent = 'Ajouter au panier';
        }
        showToast('Maillot ajouté au panier');
        fetchCart();
      })
      .catch(function (error) {
        if (button) {
          button.disabled = false;
          button.textContent = 'Ajouter au panier';
        }
        alert(error.message);
      });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () { searchProducts(searchInput.value.trim()); }, 180);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeCart();
      closeMenu();
      closeSearch();
    }
  });

  var top = document.createElement('button');
  top.id = 'back-to-top';
  top.type = 'button';
  top.setAttribute('aria-label', 'Retour en haut');
  top.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 15l-6-6-6 6"/></svg>';
  document.body.appendChild(top);
  window.addEventListener('scroll', function () {
    top.classList.toggle('visible', window.scrollY > 500);
  }, { passive: true });
  top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  document.querySelectorAll('[data-pagination-jump]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input');
      if (!input) return;
      var page = parseInt(input.value, 10);
      var max = parseInt(input.getAttribute('max'), 10) || page;
      if (!page || page < 1) page = 1;
      if (page > max) page = max;
      var url = new URL(window.location.href);
      url.searchParams.set('page', page);
      window.location.href = url.toString();
    });
  });

  fetchCart();

  // Scroll reveal — product cards & trust items
  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.product-grid .reveal, .search-grid .reveal').forEach(function (el, i) {
      el.classList.add('reveal-d' + ((i % 4) + 1));
      revealObs.observe(el);
    });

    document.querySelectorAll('.trust-strip__item').forEach(function (el, i) {
      el.classList.add('reveal', 'reveal-d' + ((i % 4) + 1));
      revealObs.observe(el);
    });
  } else {
    document.querySelectorAll('.product-grid .reveal, .search-grid .reveal, .trust-strip__item').forEach(function (el, i) {
      el.classList.add('reveal', 'reveal-d' + ((i % 4) + 1), 'visible');
    });
  }
})();
